.name-container {
    overflow: hidden;
    flex: 1;
    min-width: 0;
    display: flex;
    font-size: var(--font-huge);
    font-weight: 500;
    /* No cut off p or q characters, and no jump when moving between edit and
    read states */
    line-height: 19.5px;
}

.name-container > * {
    flex-grow: 1;
}

.name-container--deleted {
    composes: name-container;
}

.name-container--deleted button {
    text-decoration: line-through;
}

.name-container--deleted > * {
    /* We want our deleted text to float next to our name */
    flex-grow: 0;
}
